import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptUosMigration } from '../api/migration';

interface MigrationParams {
  subscriptionId: string;
  tosVersion: string;
  ownerAdminId: string;
  acknowledgments: {
    tos_acceptance: boolean;
    end_user_infrastructure_acknowledgment: boolean;
  };
}

export function useUosMigration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: MigrationParams) => acceptUosMigration(params),
    onSuccess: () => {
      // Invalidate subscriptions to refetch with updated migration status
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
}
